function EmphasizeCrossSection({emphasizeOpt}) {

  const emphasizeFixes = [];
  const linePoints =[];
  for (let i=0; i<emphasizeOpt.fixes.length; i++) {
    const fix = emphasizeOpt.fixes[i];
    if (fix.type === 'fix') {
      if(fix.fixVisible) {
        emphasizeFixes.push(<div className="emphasize-fix" style={{top: fix.top -8, left: fix.left -6}} key={i}></div>)
      }
    } else {
      linePoints.push([fix.left, fix.top]);
    }
  }

  let line;
  if(linePoints.length >= 2) {
    line = <svg className="emphasize-route-svg">
      <clipPath id="cut-off-draw-area">
        <rect x={emphasizeOpt.rulerWidth.left}
          y={emphasizeOpt.rulerWidth.top}
          width={`calc(100% - ${emphasizeOpt.rulerWidth.left + emphasizeOpt.rulerWidth.right}px)`} 
          height={`calc(100% - ${emphasizeOpt.rulerWidth.top + emphasizeOpt.rulerWidth.bottom}px)`}/>
      </clipPath>
      <polyline className="emphasize-route" points={linePoints} clipPath="url(#cut-off-draw-area)"  strokeWidth={emphasizeOpt.strokeWidth}></polyline>
    </svg>;
  }

  return (
    <>
      {line}
      {emphasizeFixes}
    </>
  )
}

export default EmphasizeCrossSection;